/**
 * Docs 도메인 Query Key 팩토리.
 *
 *  all                            → ['docs']
 *  tree(manage)                   → ['docs', 'tree', false]
 *  article(section, slug, manage) → ['docs', 'article', 'xcost-pro', 'import-boq', false]
 *
 * `manage` 를 키에 넣는 이유: 공개 응답과 관리 응답은 **내용이 다르다**(초안 포함
 * 여부). 한 키를 공유하면 관리 화면을 열었다 나온 순간 공개 화면에 초안이 남는다.
 *
 * 무효화: 문서를 쓰고 나면 tree 와 해당 article 을 **함께** invalidate 한다.
 * 트리에 제목·요약이 실려 있어서 본문만 갱신하면 사이드바가 옛 제목을 유지한다.
 */
export const docsKeys = {
  all: ['docs'] as const,
  trees: () => [...docsKeys.all, 'tree'] as const,
  tree: (manage: boolean) => [...docsKeys.trees(), manage] as const,
  articles: () => [...docsKeys.all, 'article'] as const,
  article: (section: string, slug: string, manage: boolean) =>
    [...docsKeys.articles(), section, slug, manage] as const,
  feedback: (docId: string) => [...docsKeys.all, 'feedback', docId] as const,
};
